/** @flow */

import type { State } from "@store/reducers";
import type {
  MySavedReports,
  DefaultReports,
  AlertDetailsState,
  AlertDetailsReportItem,
  AlertDetailsReportViewState,
} from "@modules/reporting/reducer/reports/alert-details/types";
import { getPagination } from "@selectors";
import type { PaginationExtendedType } from "@types";

export const getAlertDetails = (state: State): AlertDetailsState => {
  return state.reporting.reports.alertDetails;
};

export const defaultReports = (state: State): Array<DefaultReports> =>
  getAlertDetails(state).defaultReports;

export const mySavedReports = (state: State): Array<MySavedReports> =>
  getAlertDetails(state).mySavedReports;

export const getReportData = (state: State): Array<AlertDetailsReportItem> =>
  getAlertDetails(state).reportData.content;

export const getReportDataPagination = (state: State): PaginationExtendedType =>
  getPagination(getAlertDetails(state).reportData);

export const getReportDataPage = (state: State): number | null =>
  getReportDataPagination(state).pageNumber;

export const getCurrentReport = (state: State): ?Object =>
  (getAlertDetails(state).currentReport || {}).report;

export const getCurrentCharts = (state: State): ?Object => getAlertDetails(state).currentCharts;

export const getAlertDetailsFiltersSchema = (state: State): ?Object =>
  getAlertDetails(state).alertDetailsFiltersSchema;

export const getReportToSave = (state: State): ?Object => getAlertDetails(state).reportToSave;

export const getViewState = (state: State): AlertDetailsReportViewState =>
  state.reporting.reports.alertDetails.viewState;

export const isLoading = (state: State): boolean =>
  state.reporting.reports.alertDetails.requestsInProgress > 0;

export const isReportGenerateInProgress = (state: State): boolean =>
  state.reporting.reports.alertDetails.reportGenerateInProgress > 0;
